import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from './redux/actions';
import { getPagesDetails } from './ModalsMetadata';
import DropdownMenu from '../../components/DropdownMenu/DropdownMenu';

function WizardNavigation ({pages, onClick}) {

  return (
    <DropdownMenu
      title="Select pages"
      icon="hamburger"
      withIcons
      options={pages.map(page => ({
        onSelect: () => onClick(page.id),
        label: (
          <>
            <div className={`missing-fields-count ${page.wrongFieldsCount ? 'not-valid' : 'valid'}`}>{page.wrongFieldsCount > 0 ? page.wrongFieldsCount : ''}</div>
            {page.name}
          </>
        ),
      }))}
    />
  );
};

const mapStateToProps = (state, props) => {
  return {
    pagesVisibility: getPagesDetails(state.modalsVisibility.pagesVisibility.find(v => v.id === props.modalId)),
  };
};

WizardNavigation.propTypes = {
  modalId: PropTypes.string,
  changePageVisibility: PropTypes.func,
  pagesVisibility: PropTypes.array,
};

const mapDispatchToProps = dispatch => ({
  init: modalId => dispatch(actions.resetToDefault(modalId)),
  changePageVisibility: (modalId, pageId) => dispatch(actions.changePageVisibility(modalId, pageId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WizardNavigation);
